import ErrorIcon from '@mui/icons-material/Block';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Stack, Typography, useTheme } from '@mui/material';
import { ICellRendererParams } from 'ag-grid-community';

export interface IStatusRendererParams extends Pick<ICellRendererParams<unknown, string>, 'value'> {
  status: 'error' | 'hidden' | 'maybe' | 'modified' | 'pending' | 'success' | 'warning';
}

export function StatusRenderer(params: IStatusRendererParams) {
  const { value } = params;
  const status = params.status?.toLowerCase();
  const { colors } = useTheme();

  if (!value) {
    return null;
  }
  return (
    <Stack direction={'row'} alignItems={'center'} gap='0.5rem' height={'100%'}>
      {status === 'error' && <ErrorIcon color='error' fontSize='small' />}
      {status === 'hidden' && <VisibilityOffOutlinedIcon color='disabled' fontSize='small' />}
      {status === 'maybe' && <HelpOutlineOutlinedIcon color='warning' fontSize='small' />}
      {status === 'modified' && <CheckCircleIcon color='secondary' fontSize='small' />}
      {status === 'pending' && <PendingOutlinedIcon sx={{ color: '#D9D9D9' }} fontSize='small' />}
      {status === 'success' && <CheckCircleIcon color='success' fontSize='small' />}
      {status === 'warning' && <WarningAmberIcon color='warning' fontSize='small' />}
      <Typography
        variant='body2'
        color={status === 'success' ? colors.success[70] : 'text.secondary'}
        noWrap
        textTransform={'capitalize'}
      >
        {value}
      </Typography>
    </Stack>
  );
}
